<template lang="pug">
  validation-observer(ref='conflito', tag='div')
    el-card
      el-row
        el-col(:span="24")
          app-divider(:label="'Interessado'")
          el-row.margin-top( type="flex", justify="start")
          el-radio-group(v-if="!tipoChanged" v-model="setPessoaTipo" :disabled="isEdicao")
            el-radio-button(label='PF')
              i.fal.fa-user
              |  Pessoa Física
            el-radio-button(label='PJ')
              i.fal.fa-building
              |  Pessoa Jurídica
          el-row
            app-divider(
              :label="conflito.interessado.tipo == 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'"
            )

          el-row.margin-top-15(
            :gutter="30",
            type="flex",
            v-if="conflito.interessado.tipo === 'PF'",
            key="pessoaFisica"
          )
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cpf")
                app-label(
                  label="CPF:",
                  :required="true"
                )
                el-input.input(
                  v-mask="['###.###.###-##']",
                  :class="{'erro' : errors.length}",
                  v-model="conflito.interessado.pessoaFisica.cpf",
                  @blur="buscarDados",
                  suffix-icon="el-icon-search"
                  :disabled="isEdicao"
                )
                span.help.erro {{ errors[0] }}
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/nome")
                app-label(
                  label="Nome:",
                  :required="true"
                )
                el-input.input(
                  v-model="conflito.interessado.pessoaFisica.nome",
                  @blur="toUpperCase",
                  :class="{'erro' : errors.length}",
                  :maxlength="maxLengthNome"
                )
                span.help.erro {{ errors[0] }}
          el-row.margin-top-15(
            :gutter="30",
            type="flex",
            v-else,
            key="pessoaJuridica"
          )
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required|cpf_cnpj", v-slot="{ errors }", name="cadastroUsuario/cnpj")
                app-label(
                  label="CNPJ:",
                  :required="true"
                )
                el-input.input(
                  v-mask="['##.###.###/####-##']",
                  v-model="conflito.interessado.pessoaJuridica.cnpj",
                  :class="{'erro' : errors.length}",
                  @blur="buscarDados",
                  suffix-icon="el-icon-search",
                  :disabled="isEdicao"
                )
                span.help.erro {{ errors[0] }}
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="cadastroUsuario/razaoSocial")
                app-label(
                  label="Razão Social:",
                  :required="true"
                )
                el-input.input(
                  v-model="conflito.interessado.pessoaJuridica.razaoSocial"
                  @blur="toUpperCase",
                  :class="{'erro' : errors.length}",
                  :maxlength="maxLengthRazaoSocial",
                )
                span.help.erro {{ errors[0] }}
          el-row.margin-top-15(:gutter="30")
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required|email", v-slot="{ errors }", name="cadastroUsuario/email")
                app-label(
                  label="E-mail:",
                  :required="true"
                )
                el-input.input(
                  v-model="conflito.interessado.email",
                  :class="{'erro' : errors.length}",
                  :maxlength="maxLengthEmail",
                )
                span.help.erro {{ errors[0] }}
            el-col.boxInput(:span="12")
              validation-provider(mode="lazy", rules="required|email_confirmation:@cadastroUsuario/email", v-slot="{ errors }", name="cadastroUsuario/emailConfirmacao")
                app-label(
                  label="Confirmar e-mail:",
                  :required="true"
                )
                el-input.input(
                  v-model="conflito.interessado.confirmaEmail",
                  :class="{'erro' : errors.length}",
                  :maxlength="maxLengthEmail",
                )
                span.help.erro {{ errors[0] }}

          el-row.margin-top-15(:gutter="30")
            el-col.boxInput(:span="12")
              app-input-telefone(
                :telefones="conflito.interessado.telefones",
                :requiredTelefones="true",
                :nomeAba="isEdicao ? 'editUser' : 'createUser'",
                :observer="this.$refs.conflito"
              )
          app-endereco(
            :endereco="conflito.interessado.endereco"
            nomeAba="cadastroUsuario",
            :disabledFields="false",
            :upperCaseApply="true",
            :codigoEstado="conflito.interessado.endereco.municipio.codigoEstado"
            :municipio="conflito.interessado.endereco.municipio"
          )
      el-row
        el-col(:span="24")
          app-divider(:label="'Conflito'")
          el-row.margin(:gutter="30")
            el-col(:span="5")
              validation-provider(rules="required", v-slot="{ errors }", name="Origem do conflito")
                app-label(label="Origem: ", :required="true")
                el-select.input(
                  v-model="conflito.origem",
                  :class="{'erro' : errors.length}"
                  style="width: 100%;"
                )
                  el-option(
                    v-for="origem in origensConflito",
                    :key="origem.codigo",
                    :label="origem.descricao",
                    :value="origem.codigo"
                  )
                span.help.erro {{ errors[0] }}
            el-col(:span="5")
              app-label(label="Número do processo: ", :required="false")
              el-input(v-model="conflito.numeroProcesso")
            el-col(:span="5")
              app-label(label="Tipo de processo: ", :required="false")
              el-select(
                v-model="conflito.tipoProcesso.id",
                style="width: 100%;"
              )
                el-option(
                  v-for="tipo in tiposProcessos",
                  :key="tipo.id",
                  :label="tipo.nome",
                  :value="tipo.id"
                )
            el-col(:span="5")
              app-label(label="Setor: ", :required="false")
              el-input(v-model="conflito.setor", type="text")
            el-col(:span="4")
              app-label(label="N° de famílias: ", :required="false")
              el-input(v-model="conflito.numeroFamilias", type="number")
          el-row.margin(:gutter="30")
            el-col(:span="5")
              validation-provider(rules="required", v-slot="{ errors }", name="Áreas/imóveis/comunidades")
                app-label(label="Áreas/imóveis/comunidades: ", :required="true")
                el-input.input(v-model="conflito.areaImovelComunidade", :class="{'erro' : errors.length}", type="text")
                span.help.erro {{ errors[0] }}
            el-col(:span="5")
              app-label(label="Jurisdição/Dominialidade: ", :required="false")
              el-select(
                v-model="conflito.jurisdicao",
                style="width: 100%;"
              )
                el-option(
                  v-for="tipo in jurisdicao",
                  :key="tipo.codigo",
                  :label="tipo.descricao",
                  :value="tipo.codigo"
                )
            el-col(:span="5")
              validation-provider(rules="required", v-slot="{ errors }", name="Municipio conflito")
                app-label(label="Munícipio: ", :required="true")
                el-select.input(
                  v-model="conflito.municipio.id",
                  :class="{'erro' : errors.length}"
                  style="width: 100%;"
                )
                  el-option(
                    v-for="municipio in municipios",
                    :key="municipio.id",
                    :label="municipio.nome",
                    :value="municipio.id"
                  )
                span.help.erro {{ errors[0] }}
          el-row.margin(:gutter="30")
            el-col(:span="24")
              validation-provider(rules="required", v-slot="{ errors }", name="Descrição do caso")
                app-label(label="Descrição do caso: ", :required="true")
                el-input.input(v-model="conflito.descricaoCaso", type="textarea", :rows="4", :class="{'erro' : errors.length}")
                span.help.erro {{ errors[0] }}
        el-col(:span="24")
          app-label(label="Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?", :required="true")
          validation-provider(rules="required", v-slot="{ errors }", name="Possui georreferenciamento")
            el-radio-group.input.padding(
              v-model="conflito.possuiGeorreferenciamento",
              :class="{'erro' : errors.length}"
            )
              el-radio(:label="true") Sim
              el-radio(:label="false") Não
      el-row
        el-col(:span="24", v-if="conflito.possuiGeorreferenciamento")
          app-documentos(
            aba="Georreferenciamento",
            :isAnalise="true",
            :idUploadDocumento="'documentoGeorreferenciamento'",
            :titulo="'Georreferenciamento'",
            :maxSize='25000',
            :valid-extensions="extensoes",
            :documentos="documentos",
            :tiposDocumentos="tipoDocumentos",
            :tiposDocumentosObrigatorios="tipoDocumentosObrigatorios",
            :pecasTecnicas="true",
            :observer="this.$refs.conflito",
            @mudaTipo="mudaTipo",
            @setDadosPlanilha="setDadosPlanilha",
            @removedDoc="removeFile",
            @addedDoc="addedDoc"
          )
        el-col.margin(:span="24", v-if="conflito.possuiGeorreferenciamento === false")
          mapa-analise-geomensor(
            v-model="conflito.geometrias",
            :localizacoes="conflito.geometrias",
            :tipoCadastro="'NAO_ONEROSO'",
            name="Geometria",
            idMapa="mapaAnaliseGeomensor"
            :errors="[]"
            @shapefileUploaded="setShapefile"
            @shapefileRemoved="removeShapefile"
            :addPonto="true"
          )
    div.container-buttons
      el-button(
        @click="cancelar"
      ).cancelar
        i.fa.fa-times
        | &nbsp Cancelar
      el-button(
        type="primary",
        @click="salvar"
      )
        i.fa.fa-check
        | &nbsp Concluir
</template>

<script>
import { mapActions } from 'vuex'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import axios from '@/utils/api'
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import AppEndereco from '@/screens/portal/seguranca/components/AppEndereco'
import AppInputTelefone from '@/components/AppInputTelefone'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos.vue'

export default {

  components: {
    AppEndereco,
    AppLabel,
    AppDocumentos,
    MapaAnaliseGeomensor,
    AppInputTelefone
  },

  mixins: [AppNotificacao],

  props: {
    id: {
      type: String,
      required: false
    }
  },

  computed: {
    isEdicao () {
      return !!this.id
    },
    isPessoaJuridica () {
      return this.conflito.interessado.tipo === 'PJ'
    },

    isPessoaFisica () {
      return this.conflito.interessado.tipo === 'PF'
    },

    setPessoaTipo: {
      get () {
        return this.conflito.interessado.tipo
      },
      set (value) {
        this.tipoChanged = true
        this.confirmBox(this.$messages.CADASTRO_ALTERAR_TIPO_PESSOA, this.$messages.TITULO_WARNING,
          async () => {
            if (value === 'PJ') {
              this.conflito.interessado.pessoaFisica.cpf = ''
              this.conflito.interessado.pessoaFisica.nome = ''
            } else {
              this.conflito.interessado.pessoaJuridica.cnpj = ''
              this.conflito.interessado.pessoaJuridica.razaoSocial = ''
            }
            this.conflito.interessado.email = ''
            this.conflito.interessado.confirmaEmail = ''
            this.conflito.interessado.tipo = value
            this.conflito.interessado.endereco = {
              logradouro: '',
              numero: null,
              semNumero: false,
              complemento: '',
              bairro: '',
              cep: '',
              municipio: {
                id: '',
                codigoEstado: ''
              }
            }
            this.conflito.interessado.telefones = []
            this.tipoChanged = false
            this.$refs.conflito.reset()
          },
          () => { this.tipoChanged = false }
        )
      }
    }
  },
  data () {
    return {
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      conflito: {
        origem: null,
        numeroProcesso: null,
        tipoProcesso: {
          id: null
        },
        setor: null,
        numeroFamilias: null,
        areaImovelComunidade: '',
        jurisdicao: null,
        municipio: {
          id: null
        },
        documentos: [],
        interessado: {
          tipo: 'PF',
          pessoaFisica: {
            orgaoExpedidor: {}
          },
          pessoaJuridica: {
          },
          endereco: {
            municipio: {
              codigoEstado: null
            }
          },
          telefones: []
        },
        geometrias: []
      },
      origensConflito: [],
      tipoDocumentos: [],
      tiposProcessos: [],
      jurisdicao: [],
      municipios: [],
      documentos: [],
      tipoChanged: false,
      tipoDocumentosObrigatorios: []
    }
  },

  async mounted () {
    if (this.id) {
      this.conflito = await this.getConflitoById(this.id)
      this.conflito.interessado.telefones = this.conflito.interessado.telefones.map(t => t.numero)
      this.conflito.geometrias = this.conflito.geometrias.map(g => (JSON.parse(g)))
      this.conflito.interessado.confirmaEmail = this.conflito.interessado.email
      if (!this.conflito.tipoProcesso) {
        this.conflito.tipoProcesso = {
          id: null
        }
      }
      this.documentos = this.conflito.documentos.map(documento => (
        {
          id: documento.id,
          fileKey: documento.key,
          fileName: documento.nome,
          caminho: documento.caminho,
          tipoDocumento: {
            codigo: documento.tipo.codigo,
            id: documento.tipo.id,
            descricao: documento.tipo.descricao,
            tipo: documento.tipo.codigo
          }
        }
      ))
    }
    this.tipoDocumentos = await this.findTiposDocumentoTipoProcesso({
      url: 'geo',
      tipo: 'NAO_ONEROSO'
    })
    this.tipoDocumentosObrigatorios = [...this.tipoDocumentos]
    this.tipoDocumentos.push({
      id: 334,
      codigo: 'DETALHE_CONFLITO',
      descricao: 'Detalhe do conflito'
    })
    this.municipios = await this.getMunicipiosByUf('PA')
    this.origensConflito = await this.getOrigemsConflito()
    this.jurisdicao = await this.getJurisdicaoConflito()
    const tiposProcessosExcluidos = ['GENERICO']
    this.tiposProcessos = await this.getTiposProcessosPromise()
    this.tiposProcessos = this.tiposProcessos.filter(tipoProcesso => !tiposProcessosExcluidos.includes(tipoProcesso.codigo))
  },

  methods: {
    ...mapActions({
      getOrigemsConflito: 'conflito/getOrigemsConflito',
      getConflitoById: 'conflito/getConflitoById',
      getJurisdicaoConflito: 'conflito/getJurisdicaoConflito',
      getTiposProcessosPromise: 'processos/getTiposProcessosPromise',
      saveConflito: 'conflito/saveConflito',
      findTiposDocumentoTipoProcesso:
        'tipoDocumento/findTiposDocumentoTipoProcesso',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    salvar () {
      // replicando solução de contorno para validação de telefone
      delete this.$refs.conflito.refs['$ignoreTelefone$']
      this.$refs.conflito.validate().then(success => {
        if (success) {
          this.salvarCasastro()
        } else {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        }
      })
    },
    cancelar () {
      this.confirmBox(
        this.$messages.CANCECAR_CONFLITO,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({ name: 'ouvidoria/gestao-conflitos' })
        },
        () => {}
      )
    },
    salvarCasastro () {
      this.confirmBox(
        this.id ? this.$messages.CADASTRO_CONFIRM_EDIT : this.$messages.CADASTRO_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const cadastro = {
            ...this.conflito,
            tipoProcesso: this.conflito.tipoProcesso.id ? this.conflito.tipoProcesso : null,
            interessado: {
              ...this.conflito.interessado,
              telefones: this.conflito.interessado.telefones.map(t => {
                return { numero: t }
              })
            }}
          cadastro.documentos = this.documentos.map(documento => {
            return {
              id: documento.id,
              caminho: documento.caminho,
              key: documento.fileKey,
              nome: documento.fileName,
              tipo: documento.tipoDocumento
            }
          })
          if (cadastro.interessado.tipo === 'PF') {
            cadastro.interessado.pessoaJuridica = null
          } else {
            cadastro.interessado.pessoaFisica = null
          }
          this.saveConflito(cadastro).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.CONFLITO_FINALIZADO
            )
            this.$router.push({ name: 'ouvidoria/gestao-conflitos' })
          })
        },
        () => {}
      )
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'DRD_DRL':
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
        case 'OUTROS_GEOMENSOR':
          this.extensoes = ['pdf', 'jpeg', 'png', 'jpg', 'doc', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar']
          break
      }
    },
    async setDadosPlanilha (valor) {
      this.conflito.jsonPlanilha = valor.jsonPlanilha
    },
    addedDoc () {
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            })
              .then(() => {
                this.deleteAnexo(documento)
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.'
                )
              })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => {}
      )
    },
    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.conflito.documentos.indexOf(
          this.conflito.documentos.find(a => a.id === documento.id)
        )
        this.conflito.documentos.splice(index, 1)
      } else {
        const index = this.conflito.documentos.indexOf(
          this.conflito.documentos.find(a => a.key === documento.key)
        )
        this.conflito.documentos.splice(index, 1)
      }
    },
    setShapefile () {
    },
    removeShapefile () {
      this.conflito.geometrias = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .container-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .cancelar {
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/Conflito.vue